<template>
  <div class="quiz">
    <div class="quiz__container">
      <div :class="['quiz__inner', {'iframe':iframe}]">

        <template v-if="!iframe">
          <h2 class="quiz__title">Take the career change quiz</h2>
          <h3 class="quiz__sub-title">Discover your dream career and explore all the steps you need to take to get into it</h3>

          <div class="quiz__main">
            <img class="quiz__main-img" :src="`/images/quiz/quiz-screenshot.png`" alt="Career change quiz">

            <div class="quiz__main-text">
              <p>Need some career direction? We’ve partnered with our good friends at <strong>Would You Rather Be</strong> to bring you an exclusive deal on their award-winning career change platform.</p>
              <p><strong>Take 10 minutes to answer the fun, AI-powered quiz</strong> to see your career suggestions, how to get into each, along with your top transferable skills to craft successful career change job applications.</p>
              <p><strong>Escape the City users get 2 free career suggestions</strong> 🎉</p>

              <a class="quiz__btn" :href="`/career-change-quiz?utm_medium=${utm_medium}`">Take the quiz</a>
              <!-- <button v-else class="quiz__btn" @click="iframe = true">Take the quiz</button> -->

              <p class="quiz__outro">Full access from £19.49, only pay on quiz completion ✌️</p>
            </div>
          </div>
        </template>

        <iframe v-else class="quiz__iframe" :src="`https://wouldyouratherbe.com/?utm_source=esc&?utm_medium=${utm_medium}`" frameborder="0" marginwidth="0" marginheight="0"></iframe>

      </div>
    </div>
  </div>
</template>

<script>
	export default {
    name: 'CareerChangeQuiz',

    props: {
      utm_medium: {
        type: String,
        required: true
      }
    },

		data() {
			return {
        iframe: false,
			}
		},

    computed: {
      // mobileVisible() {
			// 	console.log(this.$grid.breakpoint);
      //   return ['lg','xl','2xl'].includes(this.$grid.breakpoint) ? false : true;
      // },
    },
	}
</script>

<style scoped>
  /* @import url('https://fonts.googleapis.com/css2?family=Overpass:wght@400;900&display=swap');

  .quiz {
    font-family: 'Overpass', sans-serif;
  } */
</style>
